/**
 * Icon library preview
 *
 * Draws a library entry the way the map draws it: `symbol` entries as inline SVG, because Maps
 * paints those from the path itself and there is no URI to share, and everything else through
 * `buildIconDataUri` — the same builder the marker uses, so the preview and the map cannot
 * disagree about what an entry looks like.
 */

import React from 'react';
import {ICON_KIND, buildIconDataUri} from '../../config/icon-library';

/**
 * The gallery has no device state to tint with, so every tintable entry is shown in one colour.
 */
export const PREVIEW_ICON_FILL = '#fd7e14';

const IconPreview = ({entry, size=26, fillColor=PREVIEW_ICON_FILL}) => {
    if(!entry)
    {
        return null;
    }
    if(entry.kind === ICON_KIND.SYMBOL)
    {
        return (
            <svg viewBox={entry.viewBox} width={size} height={size} role="img" aria-label={entry.label}>
                <path d={entry.path} fill={entry.tintable? fillColor: undefined}/>
            </svg>
        );
    }
    return <img src={buildIconDataUri(entry, fillColor)} width={size} height={size} alt={entry.label}/>;
};

export default IconPreview;
